import React from 'react';
import { Link } from 'react-router-dom';
import { routes } from '../../../pages/routes';
import { useAuthToken } from '../../../hooks/useAuthToken';
import { useApolloClient, useQuery } from '@apollo/client';
import { FETCH_ME } from '../../../graphql/users/queries';

type UserDropdownProps = {
  id: number;
  isCustomer: boolean;
};

const UserDropdown = ({ id, isCustomer }: UserDropdownProps) => {
  const { removeAuthToken } = useAuthToken();
  const client = useApolloClient();
  const { data: myData, loading } = useQuery(FETCH_ME);
  const isSso = ['ROLE_SUPER_ADMIN', 'ROLE_GT'].some(role => myData?.Me.roles.includes(role));

  return (
    <div className="dropdown">
      {!isCustomer && (
        <div className="dropdown-item">
          <Link to={`${routes.profile}/${id}`}>Modifier le profil</Link>
        </div>
      )}
      <div className="dropdown-item">
        <Link
          to={isSso ? routes.loginSso : routes.login}
          onClick={function () {
            removeAuthToken();
            client.cache.reset();
          }}
        >
          Se déconnecter
        </Link>
      </div>
    </div>
  );
};

export default UserDropdown;
